import { NUM_SLOTS } from '@/config/modeConfig';

const SHIFT_MINUTES = (NUM_SLOTS / 4) * 60;

/** Minutes since the shift started for an HHMM time, wrapping past midnight. */
function minutesIntoShift(hhmm: string, startHour: number): number {
  const h = parseInt(hhmm.slice(0, 2), 10);
  const m = parseInt(hhmm.slice(2), 10);
  return ((h - startHour + 24) % 24) * 60 + m;
}

/**
 * The stats marker that describes "right now".
 *
 * `now` is rounded DOWN to the half hour (1145 → 1130), then the latest marker at
 * or before that time wins. The stats text skips a half-hour entry when its zone
 * split is unchanged from the one before, so 1130 missing means 1100 still
 * applies. Returns null outside the shift window (or before the first marker).
 */
export function currentStatsMarker(markers: string[], now: Date, startHour: number): string | null {
  const nowMin = now.getHours() * 60 + now.getMinutes();
  const floored = Math.floor(nowMin / 30) * 30;
  const into = ((Math.floor(floored / 60) - startHour + 24) % 24) * 60 + (floored % 60);
  if (into >= SHIFT_MINUTES) return null;
  let best: string | null = null;
  let bestInto = -1;
  for (const mk of markers) {
    const t = minutesIntoShift(mk, startHour);
    if (t <= into && t > bestInto) { best = mk; bestInto = t; }
  }
  return best;
}

/**
 * The default "count from" time for the stats filter: now, rounded DOWN to the
 * half hour (1145 → "1130"), so copied stats start where the roster currently is
 * rather than at the start of the shift. Null outside the shift window.
 */
export function nowStartTime(now: Date, startHour: number): string | null {
  const nowMin = now.getHours() * 60 + now.getMinutes();
  const floored = Math.floor(nowMin / 30) * 30;
  const into = ((Math.floor(floored / 60) - startHour + 24) % 24) * 60 + (floored % 60);
  if (into >= SHIFT_MINUTES) return null;
  return `${String(Math.floor(floored / 60)).padStart(2, '0')}${String(floored % 60).padStart(2, '0')}`;
}
